// extracted by mini-css-extract-plugin
export default {"info":"MemberTeamInfo_info__5QOwr"};